import { render, staticRenderFns } from "./btn-primary3.vue?vue&type=template&id=e292a688&scoped=true&"
import script from "./btn-primary3.vue?vue&type=script&lang=js&"
export * from "./btn-primary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e292a688",
  null
  
)

export default component.exports